import { Component } from 'react';
import styles from '../../styles/home/sidebar.scss';
import cx from 'classnames';
import Sticky from '../ui/sticky';
import { trackAction } from '../../utils/trackActions';
import { CDN_CLRSAVE_URL } from '../../constants';

interface SidebarItem {
  iconUrl: string;
  label: string;
  value: string;
}

interface SidebarProps {
  items: SidebarItem[];
}

class Sidebar extends Component<any, any> {
  constructor(props: SidebarProps) {
    super(props);
    this.state = { tab: 'best-tax-saving' };
  }

  public highlightTab = () => {
    const { items } = this.props;
    const navItems = items.map(item => item.value);
    const windowScroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const offset = 50;
    navItems.map(item => {
      const el = document.querySelector(`#${item}`);
      if (el) {
        const { offsetTop, clientHeight } = el;
        if (
          windowScroll + offset > offsetTop &&
          windowScroll + offset < offsetTop + clientHeight
        ) {
          if (this.state.tab !== item) {
            this.setState({ tab: item });
            trackAction('view-section', 'save', item);
          }
        }
      }
    });
  };

  private handleTagClick = (e: any) => {
    e.preventDefault();
    const selector = e.target.dataset.tag || e.currentTarget.dataset.tag;
    trackAction('click-section', 'save', selector);
    const el = document.querySelector(`.${selector}`);
    window.scrollTo({
      top: el.offsetTop + 400,
      behavior: 'smooth',
    });
  };

  public componentDidMount() {
    this.highlightTab();
    window.addEventListener('scroll', this.highlightTab);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.highlightTab);
  }

  public render() {
    const { items } = this.props;
    const { tab } = this.state;
    return (
      <Sticky
        marginLeftRequired={true}
        noWidth={true}
        hideShadow={true}
        noPadding={true}
        hideAfter="request-callback"
        hideAfterOffset={300}
      >
        <div
          className={cx(styles['sidebar-container'])}
          ref={(sticky: any) => (this.sticky = sticky)}
        >
          {items.map((item: SidebarItem) => {
            const { label, iconUrl, value } = item;
            return (
              <div
                className={cx(styles['sidebar-item'], {
                  [styles['sidebar-item--active']]: value === tab,
                })}
                data-tag={`${value}-block`}
                onClick={this.handleTagClick}
                key={label}
              >
                <img className={cx('verticle-align-middle')} src={iconUrl} />
                <span
                  className={cx(
                    'font--dark-grey text--xmd font--bold ml10 inline-block',
                    styles['title']
                  )}
                >
                  {label}
                </span>
                <img
                  className={`verticle-align-middle ${styles['arrow']}`}
                  src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/Arrow.svg`}
                />
              </div>
            );
          })}
        </div>
      </Sticky>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./components/home/sidebar.tsx